<template>
  <div>
    <div
      class="py-4 px-6 flex flex-col justify-center items-center w-32 overflow-hidden border cursor-pointer"
      v-for="item in list"
      :class="active.id === item.id && 'text-primary'"
      @click="clickItem(item)"
    >
      <div class="flex items-center justify-between">
        <i
          class="iconfont icon-up p-2"
          v-if="item.parentId && active.id === item.id"
          @click.stop="clickUpOrDown(item, 'up')"
        />
        <span class="w-16 overflow-hidden inline-block text-center">
          {{ item?.displayText }}
        </span>
        <i
          v-if="item.parentId && active.id === item.id"
          class="iconfont icon-down p-2"
          @click.stop="clickUpOrDown(item, 'down')"
        />
      </div>
      <div class="mt-3" v-if="item.parentId && active.id === item.id">
        <i
          class="iconify mingcute--edit-3-line p-2"
          @click.stop="clickEdit(item)"
        />
        <i class="iconfont icon-delete p-2" @click.stop="clickDel(item)" />
        <i class="iconfont icon-a- p-2" @click.stop="clickAddChild(item)" />
      </div>
    </div>

    <div class="text-center py-5 border" v-if="parentId">
      <i class="iconfont icon-a- p-2" @click.stop="clickAdd" />
    </div>
  </div>
  <Tree
    v-if="active.id && nextList.length > 0"
    ref="treeDOM"
    :list="nextList"
    :parent-id="active.id"
  />
</template>

<script lang="ts" setup>
import { ref } from "vue";
import Tree from "./Tree.vue";
import { usePromptManager } from "@/stores/manager";
import { showDialog } from "vant";
import { watch } from "vue";
import { usePrompts } from "@/stores/prompts";
import { nextTick } from "vue";
import i18n from "@/locales";

const managerStore = usePromptManager();
const promptStore = usePrompts();

const props = defineProps<{
  list: any[];
  parentId?: number;
}>();

const nextList = ref<any[]>([]);
const active = ref<any>({});
const treeDOM = ref<any>(null);

watch([() => nextList.value], (val) => {
  if (treeDOM.value) active.value = {};
});

defineExpose({
  nextList,
});

const clickItem = (item: any) => {
  active.value = item;
  nextList.value = item.children;
  nextTick(() => {
    const el = managerStore.allDom;
    el.scrollLeft = el.scrollWidth;
  });
};

const selectItem = (item: any) => {
  active.value = item;
  nextList.value = item.children;
};

const clickEdit = (item: any) => {
  selectItem(item);
  managerStore.showEdit = true;
  managerStore.editCache = {
    id: item.id,
    parentId: item.parentId,
    text: item.text,
    displayText: item.displayText,
    children: [],
  };
  managerStore.activeEditObj = item;
};

const clickAdd = () => {
  managerStore.showEdit = true;
  const id = ++promptStore.maxId;
  let obj = {
    id,
    parentId: props.parentId!,
    displayText: "",
    text: "",
    children: [],
  };
  managerStore.editCache = obj;
  managerStore.activeEditObj = props.list;
};

const clickAddChild = (item: any) => {
  selectItem(item);
  managerStore.showEdit = true;
  const id = ++promptStore.maxId;
  let obj = {
    id,
    parentId: item.id,
    displayText: "",
    text: "",
    children: [],
  };
  managerStore.editCache = obj;
  managerStore.activeEditObj = nextList.value;
};

const clickUpOrDown = (item: any, type: "up" | "down") => {
  const index = props.list.findIndex((i) => i.id === item.id);
  if (type === "up") {
    if (index === 0) return;
    props.list.splice(index, 1);
    props.list.splice(index - 1, 0, item);
  } else {
    if (index === props.list.length - 1) return;
    props.list.splice(index, 1);
    props.list.splice(index + 1, 0, item);
  }
};

const clickDel = (item: any) => {
  showDialog({
    title: i18n.global.t("ConfirmModal.promptTitle"),
    message: i18n.global.t("ConfirmModal.sureDeleteDisplayText", {
      displayText: item.displayText,
    }),
    confirmButtonText: i18n.global.t("Buttons.confirm"),
    cancelButtonText: i18n.global.t("Buttons.cancel"),
    showCancelButton: true,
  })
    .then(() => {
      const index = props.list.findIndex((i) => i.id === item.id);
      props.list.splice(index, 1);
    })
    .catch(() => {});
};
</script>
